import React, { useEffect, useState } from "react";
import { Autocomplete, Button, Divider, Grid, Typography } from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconArrowBack } from "@tabler/icons";
import GeofencingService from "src/service/geofencing";
import UserService from "src/service/userService";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Add User ",
  },
];

const validationSchema = yup.object({
  username: yup
    .string("Enter User Name")
    .matches(
      /^[a-z]+$/,
      "User Name should only contain small Alphabet without space"
    )
    .min(2, "User Name should be of minimum 2 characters in length")
    .max(30, "User Name should be of maximum 30 characters in length")
    .required("User Name is required"),

  contact: yup
    .string("Enter Contact No")
    .matches(/^[0-9]+$/, "Contact No should only contain digits")
    .min(10, "Contact number should be at least 10 digits long")
    .max(10, "Contact number should not exceed 10 digits")
    .required("Contact no is Required"),
});

const AddUserList = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [districtList, setDistrictList] = useState([]);

  const fetchDistrictList = async () => {
    try {
      const res = await GeofencingService.fetch_district_list({});
      setDistrictList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDistrictList();
  }, []);

  const initialValues = {
    district_id: "",
    vehicle_type: "",
    username: "",
    contact: "",
    c_by: sessionData.data.id,
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // console.log("check values----", values);
      try {
        const res = await UserService.addUserData(values);
        swal("success", res.message, "success");
        setTimeout(() => {
          navigate("/userlist");
        }, 1000);
      } catch (error) {
        swal("error", error.message, "error");
      }
    },
  });

  const vehicleTypeOptions = [
    { value: "e", label: "ERV" },
    { value: "f", label: "Fire Brigade" },
    { value: "e,f", label: "Both ERV & Fire Brigade" },
  ];

  return (
    <>
      <Breadcrumb title="Add User List" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Add User List
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/userlist");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "5px" }}>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="username">
                User Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="username"
                name="username"
                type="text"
                value={formik.values.username}
                onChange={(e) => {
                  const value = e.target.value.toLowerCase().replace(/\s/g, "");
                  formik.setFieldValue("username", value);
                }}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.username && Boolean(formik.errors.username)
                }
                helperText={formik.touched.username && formik.errors.username}
                variant="outlined"
                placeholder="Enter username"
                fullWidth
              />
            </Grid>
            {/* ==== Contact no ===  */}
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="contact">
                Contact No
                <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="contact"
                name="contact"
                type="text"
                value={formik.values.contact}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.contact && Boolean(formik.errors.contact)}
                helperText={formik.touched.contact && formik.errors.contact}
                variant="outlined"
                placeholder="Enter Contact no"
                fullWidth
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="district_id">
                District <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>

              <Autocomplete
                id="district_id"
                name="district_id"
                options={districtList}
                getOptionLabel={(option) => `${option.district_name}`}
                value={
                  districtList.find(
                    (district) => district.id === formik.values.district_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  formik.setFieldValue("district_id", newValue?.id || "");
                }}
                onBlur={formik.handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={
                      formik.touched.district_id &&
                      Boolean(formik.errors.district_id)
                    }
                    helperText={
                      formik.touched.district_id && formik.errors.district_id
                    }
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select a District"
                  />
                )}
              />
            </Grid>

            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="vehicle_type">
                Vehicle Type <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="vehicle_type"
                name="vehicle_type"
                options={vehicleTypeOptions}
                getOptionLabel={(option) => `${option.label}`}
                value={
                  vehicleTypeOptions.find(
                    (item) => item.value === formik.values.vehicle_type
                  ) || null
                }
                onChange={(event, newValue) => {
                  formik.setFieldValue("vehicle_type", newValue?.value || "");
                }}
                onBlur={formik.handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={
                      formik.touched.vehicle_type &&
                      Boolean(formik.errors.vehicle_type)
                    }
                    helperText={
                      formik.touched.vehicle_type && formik.errors.vehicle_type
                    }
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select a vehicle type"
                  />
                )}
              />
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <Button color="primary" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </>
  );
};

export default AddUserList;
